module.exports = __webpack_public_path__ + "7ff699d1e1592bc56fa011466d55ae14.fbx";